import { gql } from "@apollo/client";

export const CreateCodeGroupMutation = gql`
  mutation ($codeGroup: CodeGroupInput!) {
    createCodeGroup(codeGroup: $codeGroup) {
      codeGroupId
    }
  }
`;

export const UpdateCodeGroupMutation = gql`
  mutation ($codeGroup: CodeGroupInput!, $id: String!) {
    updateCodeGroup(codeGroupUpdate: $codeGroup, id: $id) {
      code
      text
    }
  }
`;

export const createDraftCodeGroupMutation = gql`
  mutation CreateDraftCodeGroup($codeGroup: CodeGroupDraftInput!) {
    createDraftCodeGroup(codeGroup: $codeGroup) {
      codeGroupId
    }
  }
`;
export const updateDraftCodeGroupMutation = gql`
  mutation UpdateDraftCodeGroup($id: String!, $codeGroup: CodeGroupDraftInput!) {
    updateDraftCodeGroup(id: $id, codeGroup: $codeGroup) {
      code
      text
    }
  }
`;

export const updateCodeGroupsActiveEndDateMutation = gql`
  mutation UpdateCodeGroupsActiveEndDate(
    $batchCodeGroupsInput: BatchCodeGroupsInput!
  ) {
    updateCodeGroupsActiveEndDate(batchCodeGroupsInput: $batchCodeGroupsInput) {
      codeGroupsId
      code
      text
    }
  }
`;

export const configureMultiFileDownloadMutation = gql`
  mutation ConfigureMultiFileDownload($input: MultiFileDownloadConfigInput!) {
    configureMultiFileDownload(input: $input) {
      status
      message
      jobId
    }
  }
`;

export const getCodeGroupExportJobsMutation = gql`
  mutation GetCodeGroupExportJobs($input: CodeGroupExportJobsInput!) {
    getCodeGroupExportJobs(input: $input) {
      codeGroupId
      jobs {
        jobId
        status
        numOfFolders
        notificationEmailAddress
        createdBy
        createdAt
        updatedAt
        downloadUrl
        urlExpiresAt
        downloadStatusMessage
        folders {
          folderId
          folderName
          fileName
          status
          numOfCodes
          numOfFiles
          createdAt
          updatedAt
        }
      }
    }
  }
`;
